import { Chip, Flex, Menu } from '@elementary/common-ui/components';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Typography } from '@mui/material';
import { CustomQueryDestination } from 'shared/types';
import { isCustomQueryDestination } from './customSqlCloudTest';

export type StackOption = {
  stack: CustomQueryDestination;
  label: string;
  recommended?: boolean;
  disabledReason?: string;
};

type Props = {
  options: StackOption[];
  value?: CustomQueryDestination;
  onChange: (stack: CustomQueryDestination) => void;
};

const TestStackSelector = ({ options, value, onChange }: Props) => {
  const menuOptions = options.map((option) => ({
    value: option.stack,
    label: option.recommended ? `${option.label} (recommended)` : option.label,
    disabled: !!option.disabledReason,
    description: option.disabledReason,
  }));
  const selected =
    options.find((option) => option.stack === value) ?? options[0];

  return (
    <Menu
      menuButton={
        <Chip
          customVariant="rounded"
          overflow="visible"
          aria-label="Test implementation"
          sx={{ cursor: 'pointer' }}
          label={
            <Flex sx={{ alignItems: 'center', gap: 0.5 }}>
              <Typography sx={{ fontSize: 14, color: 'common.gray2' }}>
                {selected?.label}
              </Typography>
              {selected?.recommended && (
                <Typography sx={{ fontSize: 14, color: 'common.gray4' }}>
                  (recommended)
                </Typography>
              )}
              <KeyboardArrowDownIcon
                sx={{ fontSize: 18, color: 'common.gray4', ml: 0.25 }}
              />
            </Flex>
          }
        />
      }
      options={menuOptions}
      selectedOptions={value ? [value] : []}
      onChange={(stack) => {
        if (!isCustomQueryDestination(stack)) {
          return;
        }
        onChange(stack);
      }}
      closeOnChange
      highlightSelected
    />
  );
};

export default TestStackSelector;
